// METIER

/**
 * Génère un UUID v4 simplifié sans dépendances externes.
 * Note: Cette implémentation n'est pas cryptographiquement sécurisée.
 * Pour une utilisation en production nécessitant une haute sécurité,
 * considérez l'utilisation d'une bibliothèque dédiée ou de l'API Web Crypto.
 *
 * @returns {string} Un UUID v4 généré.
 */
export function generateUUID(): string {
    const hexDigits = "0123456789abcdef";
    let uuid = "";

    for (let i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            uuid += "-";
        } else if (i === 14) {
            uuid += "4"; // Version 4
        } else if (i === 19) {
            uuid += hexDigits[(Math.random() * 4) | 8]; // Variant
        } else {
            uuid += hexDigits[(Math.random() * 16) | 0];
        }
    }

    return uuid;
}

// Exemple d'utilisation
// const myUUID = generateUUID();
// console.log(myUUID); // Par exemple : "f47ac10b-58cc-4372-a567-0e02b2c3d479"
